import { showToast } from '../../application/utils/toast.util';
import {client} from '../../core/stores';

import {QUERY_GET_ALUNOS} from '../../core/graphql/types';

import {UserProps} from '../../application/types';

type QueryGetAlunosReturn = {
  status: string;
  data: {
    page: number;
    totalPages: number;
    list: UserProps[];
  }
}

type QueryGetAlunosFunction = { ( page: number, search: string) : Promise<QueryGetAlunosReturn>; }

export function QueryGetAlunos(page = 1, search = '') : QueryGetAlunosFunction<QueryGetAlunosReturn> {
  const variables = { page, search };
  return new Promise<QueryGetAlunosReturn>((resolve, reject) => {
    client('account').query({query: QUERY_GET_ALUNOS, variables})
    .then( ({data: {alunos} }) => resolve({status: 'success', data: {...alunos}}) )
    .catch( err => {
      const errorMessage = err.graphQLErrors.map((error) => error.message).join(',');
      showToast({ html: 'Houve um erro ao tentar carrega a lista de alunos' });
      showToast({ html: errorMessage });
      return reject(reject({status: 'error', message: errorMessage}));
    })
  })
}